import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
	path: '/',
	name: 'netbaoming',
    component: () => import( '../views/baomingtable.vue'),
    meta: { title: '报名列表' }
  },
  {
    path: '/baomingtable',
    name: 'baomingtable',
    component: () => import( '../views/baomingtable.vue')
  },
  {
	path: '/register',
	name: 'Register',
	component: () => import('../views/Register.vue'),
    meta: { title: '登录注册' }
  },
  {
    path: '/mianshi',
    name: 'mianshi',
    component: () => import('../views/mianshi.vue'),
    meta: { title: '参加面试' }
  },
  {
    path: '/jindu',
    name: 'jindu',
    component: () => import( '../views/bmgongshi.vue'),
    meta: { title: '报名进度公示' }
  },
  {
    path: '/tishi',
    name: 'tishi',
    component: () => import('../views/tishi.vue'),
    meta: { title: '考生提示' }
  },
  {
    path: '/xieyi',
    name: 'xieyi',
    component: () => import( '../views/xieyi.vue'),
    meta: { title: '考生须知' }
  },
  {
    path: '/tianbaoxinxi',
    name: 'tianbaoxinxi',
    component: () => import( '../views/tianbaoxinxi.vue'),
    meta: { title: '填写报名信息' }
  },
  {
    path: '/tianbaoxinxi2',
    name: 'tianbaoxinxi2',
    component: () => import( '../views/tianbaoxinxi2.vue'),
    meta: { title: '填写报名信息' }
  },
  {
    path: '/status',
    name: 'status',
    component: () => import('../views/status.vue'),
    meta: { title: '报名状态' }
  },
  {
    path: '/photo',
    name: 'photo',
    component: () => import('../views/photo.vue'),
    meta: { title: '上传照片' }
  },
  {
    path: '/printbaoming',
    name: 'printbaoming',
    component: () => import( '../views/printbaoming.vue'),
    meta: { title: '报名表打印' }
  },
  {
    path: '/printzheng',
    name: 'printzheng',
    component: () => import('../views/printzheng.vue'),
    meta: { title: '准考证打印' }
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import( '../views/pay.vue'),
    meta: { title: '报名缴费' }
  },
  {
    path: '/pay2',
    name: 'pay2',
    component: () => import( '../views/pay2.vue'),
    meta: { title: '报名缴费' }
  },
  {
    path: '/chengji',
    name: 'chengji',
    component: () => import('../views/chengji.vue'),
    meta: { title: '考试成绩' }
  },
  {
    path: '/chongzhipas',
    name: 'chongzhipas',
    component: () => import( '../views/chongzhipas.vue'),
    meta: { title: '重置密码' }
  },
  {
    path: '/fortpas',
    name: 'fortpas',
    component: () => import( '../views/fortpas.vue'),
    meta: { title: '充值密码' }
  },
  {
    path: '/xuhao',
    name: 'xuhao',
    component: () => import( '../views/xuhao.vue'),
    meta: { title: '找回报名序号' }
  },
  {
    path: '/sucxuhao',
    name: 'sucxuhao',
    component: () => import( '../views/sucxuhao.vue'),
    meta: { title: '找回报名序号' }
  }
  
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  if (to.meta.title) {
    document.title = to.meta.title+'-网上考试报名系统';
  }
  next()
});
export default router
